import React, { useState, useEffect, useMemo } from 'react';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import DataTable from 'react-data-table-component';
const utils = require('../../components/utils');

const baseUrl = `${window.nobid_endpoint}/mamova`;
const conditionalRowStyles = [
	{
			when: row => row?.status === 'critical',
			style: {color: 'red', backgroundColor: 'white'}
	},
	{
    when: row => row?.status === 'warning',
    style: {color: 'orange', backgroundColor: 'white'}
  },
];
const tableColumns = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => <span>{ row.date.substring(0, row.date.lastIndexOf('/')) }</span> },
  { name: 'Name', selector: 'name', sortable: true, width: '40%' },
  { name: 'Type', selector: 'type', sortable: true },
  { name: 'Status', selector: 'status', sortable: true },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span> }
];
let tableData = [];
const MarketMoversAnalysisComponent = ({params, parentLoading}) => {
  const [loading, setLoading] = useState(true);

  const updateState = (results) => {
    tableData = results;
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    let url = `${baseUrl}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (parentLoading) getData() }, [parentLoading]);
 
  return (
    <Card style={{width: '100%'}} raised>
    <CardContent style={{ textAlign: 'center', fontSize: '37px', fontWeight: '600', color: 'white' }}>
    <div style={{position: 'relative'}}>
      <div>
        <div style={{float: 'left', paddingRight: '10px', paddingBottom: '20px'}}>
        <Tooltip title={
        <React.Fragment>This analysis compares the revenue of Publishers, Sites and Bidders over an 8 days period and shows the inventory that has droped.<ul><li>A "warning" status means that the entiy has dropped in the bottom 15th position.</li><li>A "critical" status, means that the entity in no longer in the top 20 and needs immediate attention.</li></ul></React.Fragment>
        }>
          <HelpIcon/>
        </Tooltip>
        </div>
        <div style={{float: 'left'}}>
          <span style={{fontSize: '22px'}}>Market Anomalies</span> <span style={{fontSize: '12px'}}>- based on the past 8 days revenue including today</span>
        </div>
      </div>
      <DataTable
        noHeader={true}
        theme={window.nobid_table_theme()}
        columns={tableColumns}
        data={tableData}
        progressPending={loading}
        conditionalRowStyles={conditionalRowStyles}
        pagination
        fixedHeader
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        dense
        highlightOnHover
      />
    </div>
    </CardContent>
    </Card>
  )
}

export default MarketMoversAnalysisComponent;
